import {useCallback} from 'react';

import {DmsDataGrid} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface ActivityLogDataGridProps extends RequiredTestIdProps {
  orderId: string | Nullish;
}

export function ActivityLogDataGrid(props: ActivityLogDataGridProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) => ({
      ...filter,
      serviceOrderId: String(props.orderId),
    }),
    [props.orderId]
  );

  return (
    <DmsDataGrid
      autoHeight
      gridCode="activity-log-service-order"
      data-testid={suffixTestId('activityLog', props)}
      queryModifier={queryModifier}
    />
  );
}
